import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { columnObjectType, rowType, mergeDocumentType } from "custom-prop-types";
import styles from "components/documents/merge-grid.scss";

export const MergeGrid = (props) => (
  <table className={ styles.table }>
    <thead className={ styles.thead }>
      <TableHeaders columns={ props.columns } />
    </thead>
    <TableData { ...props } />
  </table>
);

MergeGrid.propTypes = {
  columns: PropTypes.arrayOf(columnObjectType).isRequired
};

const TableHeaders = ({ columns }) => {
  const headers = columns.map((column) => (
    <th className={ styles.th } key={ column.key }>
      { column.name }
    </th>
  ));
  return <tr>{ headers }</tr>;
};

TableHeaders.propTypes = { columns: PropTypes.arrayOf(columnObjectType).isRequired };

const TableData = (props) => {
  const data = props.rows.map((row) => <TableRow { ...props } key={ row.id } row={ row } />);
  return <tbody>{ data }</tbody>;
};

TableData.propTypes = MergeGrid.propTypes;

const TableRow = ({
  columns,
  onCellSelected,
  onRowsDeselected,
  onRowsSelected,
  row,
  selectedFields
}) => {
  const rowItems = columns.map((column) => {
    if (column.formatter !== undefined) {
      return (
        <ColumnFormatter
          column={ column }
          key={ `${row.id}-${column.key}` }
          onCellSelected={ onCellSelected }
          onRowsDeselected={ onRowsDeselected }
          onRowsSelected={ onRowsSelected }
          row={ row }
          selectedFields={ selectedFields }
        />
      );
    }
    return (
      <td
        className={ cellClassNameToggle(selectedFields, column, row) }
        key={ `${row.id}-${column.key}` }
        onClick={ () => onCellSelected(column.key, row[column.key], row.id) }
      >
        { row[column.key] }
      </td>
    );
  });
  return (
    <tr className={ row.isSelected ? styles["selected-row"] : styles.tr } key={ row.id }>
      { rowItems }
    </tr>
  );
};

TableRow.propTypes = {
  columns: PropTypes.arrayOf(columnObjectType).isRequired,
  onCellSelected: PropTypes.func.isRequired,
  onRowsDeselected: PropTypes.func.isRequired,
  onRowsSelected: PropTypes.func.isRequired,
  row: rowType.isRequired,
  selectedFields: mergeDocumentType
};

const ColumnFormatter = ({
  column,
  onRowsDeselected,
  onRowsSelected,
  onCellSelected,
  row,
  selectedFields
}) => {
  const Formatter = column.formatter;
  if (column.key === "isSelected") {
    return (
      <td className={ styles.td }>
        <Formatter
          id={ row.id }
          isSelected={ row[column.key] }
          onRowsDeselected={ onRowsDeselected }
          onRowsSelected={ onRowsSelected }
        />
      </td>
    );
  }
  return (
    <td
      className={ cellClassNameToggle(selectedFields, column, row) }
      onClick={ () => onCellSelected(column.key, row[column.key], row.id) }
    >
      <Formatter value={ row[column.key] } />
    </td>
  );
};

ColumnFormatter.defaultProps = {
  selectedFields: null
};

ColumnFormatter.propTypes = {
  column: columnObjectType.isRequired,
  onCellSelected: PropTypes.func.isRequired,
  onRowsDeselected: PropTypes.func.isRequired,
  onRowsSelected: PropTypes.func.isRequired,
  row: rowType.isRequired,
  selectedFields: mergeDocumentType
};

const cellClassNameToggle = (selectedFields, column, row) => {
  const id = R.path([column.key, "id"], selectedFields);
  return id === row.id ? `${styles.td} ${styles.td__active}` : styles.td;
};



// WEBPACK FOOTER //
// ./src/js/components/documents/merge-grid.jsx